import { useEffect } from 'react';
import { useT } from '../../i18n/i18n';
import { aiJobsStore, dismissAiJobNotice } from '../../state/aiJobsStore';
import { useStore } from '../../state/createStore';
import { Icon } from '../../ui/components';
import { openAdvancedResult } from './openAdvancedResult';

// In-app completion notice (Owner contract 2026-09-13 §9 "App 正在前台"): a tappable pill at the top
// of the screen — 高级 AI 复核完成 · 地下室 · 东墙 — that never blocks input, never navigates by
// itself, and goes away on its own. Tapping it opens the result as a detour (§11).
export const AI_JOB_NOTICE_MS = 10_000;

export function AiJobNoticeHost() {
  const { t } = useT();
  const notices = useStore(aiJobsStore, (s) => s.notices);
  const jobs = useStore(aiJobsStore, (s) => s.jobs);
  const first = notices[0] ?? null;
  const job = first ? (jobs.find((j) => j.id === first.jobId) ?? null) : null;
  const noticeId = first?.id ?? null;

  useEffect(() => {
    if (!noticeId) return undefined;
    const timer = setTimeout(() => dismissAiJobNotice(noticeId), AI_JOB_NOTICE_MS);
    return () => clearTimeout(timer);
  }, [noticeId]);

  if (!first || !job) return null;
  const subject = [job.subject.areaName, job.subject.itemTitle].filter((s): s is string => typeof s === 'string' && s.length > 0).join(' · ');
  return (
    <div className="ai-notice-host" data-testid="ai-notice-host" role="status" aria-live="polite">
      <button
        type="button"
        className="ai-notice"
        onClick={() => {
          dismissAiJobNotice(first.id);
          openAdvancedResult(job);
        }}
        data-testid="ai-notice"
        data-job-id={job.id}
      >
        <span className="sparkle-inline">✦</span>
        <span className="ai-notice-text">{t('advanced.completeToast', { subject })}</span>
        <Icon name="chevron_right" />
      </button>
      <button type="button" className="ai-notice-close" onClick={() => dismissAiJobNotice(first.id)} aria-label={t('shell.close')} data-testid="ai-notice-close">
        <Icon name="close" />
      </button>
    </div>
  );
}
